import type { PassId } from '../data/passes'
import type { Stamp, SkiDay } from './types'

/** Compact public season card payload (URL-safe). */
export interface SeasonCardPayload {
  v: 1
  n: string
  p: PassId
  s: string
  stamps: Array<{ id: string; st: 'visited' | 'want'; d?: string }>
  days: number
  price: number
}

export function encodePayload(data: unknown): string {
  const json = JSON.stringify(data)
  const b64 = btoa(unescape(encodeURIComponent(json)))
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function decodePayload<T>(raw: string): T | null {
  try {
    const pad = raw.length % 4 === 0 ? '' : '='.repeat(4 - (raw.length % 4))
    const b64 = raw.replace(/-/g, '+').replace(/_/g, '/') + pad
    const json = decodeURIComponent(escape(atob(b64)))
    return JSON.parse(json) as T
  } catch {
    return null
  }
}

export function buildSeasonPayload(opts: {
  name: string
  passId: PassId
  seasonLabel: string
  stamps: Stamp[]
  days: SkiDay[]
  priceUsd: number
}): SeasonCardPayload {
  return {
    v: 1,
    n: opts.name || 'Skier',
    p: opts.passId,
    s: opts.seasonLabel,
    stamps: opts.stamps.map((t) => ({
      id: t.resortId,
      st: t.status,
      ...(t.date ? { d: t.date } : {}),
    })),
    days: opts.days.length,
    price: opts.priceUsd,
  }
}
